import { Col } from "react-bootstrap";

const TimelineItem = ({
  icon,
  label,
  date,
  status = "",
  className = "",
  variant = "",
  enableVariant = false
}) => {
  const variantClass = enableVariant ? variant : "";

  return (
    <Col className="timeline-col">
      <div className={`timeline-icon ${status} ${className} ${variantClass}`}>
        <img
          src={icon}
          alt={label}
          className="timeline-img"
        />
      </div>
      <div className="timeline-label">{label}</div>
      <div className="timeline-date">{date}</div>
    </Col>
  );
};

export default TimelineItem;
